import React from 'react';
import { Icon } from 'semantic-ui-react';
import { Button, USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const PipelinesToolbar = ({ disableAddBtn, onOpenAddPipeline }) => {
    return (
        <div className='LeadPipelineOptions'>
            <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PIPELINE_ADD}>
            <Button className='LeadPipelineOptions__NewPipelineButton' onClick={onOpenAddPipeline} disabled={disableAddBtn}>
                <Icon name='plus' /> New Pipeline
            </Button>
            </RestrictedView>
        </div>
    );
}

export default PipelinesToolbar;
